module.exports = __webpack_public_path__ + "img/hero-image-non-logged-se.010f6411.png";